import { IResidentsService } from "../services/IResidentsService";
import { INotificationService } from "../../common/services/INotificationService";
import _ = require("underscore");
import { IDialogService } from "../../common/services/IDialogService";
import { ResidentEventType, EventHistory, EventsHistoryRow, CareType } from "../Models";
import { IIndependentLivingService } from "../../independentLiving/services/IIndependentLivingService";
import { ViewEnquiryDto } from "../../independentLiving/Models";

class ResidentEventHistoryComponent implements ng.IComponentOptions {
    public bindings: any = {};
    public templateUrl: string = 'app/residents/partials/residentEventHistory.html';

    constructor() {
        this.bindings = {
            residentId: "="
        };
    }

    public controller: any = class ResidentEventHistoryController {
        static $inject = ['residents.service', 'notification.service', 'dialog.service', '$state', 'authentication.service', 'independentLiving.service'];

        public eventHistory: EventHistory;
        private residentId: number;
        private isReadOnly: boolean;
        private hasReverseEventPermission: boolean;
        private enquiry: ViewEnquiryDto

        constructor(private readonly residentService: IResidentsService,
            private readonly notificationService: INotificationService,
            private readonly dialogService: IDialogService,
            private $state: ng.ui.IStateService,
            private readonly authenticationService: any,
            private readonly independentLivingService: IIndependentLivingService
        ) {
            this.loadEventHistory();
            this.setFundingCorrectEventsPermission();
            this.setFundingReverseEventsPermission();
        }

        private loadEventHistory = () => {
            this.residentService.getEventHistory(this.residentId).then((response) => {
                this.eventHistory = response;
            }, (error) => {
                this.notificationService.error("Unexpected error while retrieving resident event history");
            })
        }

        public editEvent = (id: number): void => {
            const eventHistoryItem = _.find(this.eventHistory.eventsHistory, (event) => {
                return event.id == id;
            });

            if (this.canEdit(eventHistoryItem)) {
                if (eventHistoryItem.careType.toString() === "ILU") {
                    this.independentLivingService.getEnquiry(eventHistoryItem.enquiryId, eventHistoryItem.isDeparted, null).then(response => {
                        this.enquiry = response;

                        const { template, controller, modelConfig } = this.getTemplate(eventHistoryItem.eventType, eventHistoryItem);
                        this.dialogService.openDialog(template, controller, modelConfig);
                    },
                        (error) => {
                            this.notificationService.error("Unexpected error while attempting to get enquiry");
                        });
                }
                else {
                    const { template, controller, modelConfig } = this.getTemplate(eventHistoryItem.eventType, eventHistoryItem);
                    this.dialogService.openDialog(template, controller, modelConfig);
                }
            }
        }

        public editLeave = (id: number) => {
            const leaveEvent = _.find(this.eventHistory.leaves, (leave) => {
                return leave.id == id;
            });

            this.dialogService.openDialog("app/residents/partials/sendOnLeaveDialog.html", "sendOnLeaveDialog.controller", {
                isReadOnly: this.isReadOnly,
                hasReverseEventPermission: this.hasReverseEventPermission,
                resident: {
                    id: this.residentId,
                    firstName: this.eventHistory.latestResidency.firstName,
                    lastName: this.eventHistory.latestResidency.lastName,
                    careType: leaveEvent.careType,
                    leave: {
                        id: leaveEvent.id,
                        facility: leaveEvent.facility,
                        facilityId: leaveEvent.facilityId,
                        startDateUtc: leaveEvent.startDateUtc,
                        leaveStartTimeLocalString: leaveEvent.leaveStartTimeLocalString,
                        expectedReturnDateUtc: leaveEvent.expectedReturnDateUtc,
                        type: leaveEvent.type,
                        isReversed: leaveEvent.isReversed,
                        comments: leaveEvent.comments,
                        returnDateUtc: leaveEvent.returnDateUtc,
                        leaveReturnTimeLocalString: leaveEvent.leaveReturnTimeLocalString,
                        respiteLeaveFacilityIdWithinResman: leaveEvent.respiteLeaveFacilityIdWithinResman,
                        isRespiteLeaveWithinOrganisation: leaveEvent.isRespiteLeaveWithinOrganisation,
                        respiteLeaveExternalFacilityDetails: leaveEvent.respiteLeaveExternalFacilityDetails
                    }
                },
                uniqueEventId: leaveEvent.uniqueEventId,
                isCorrection: true,
                origin: "eventsHistory",
                requestType: "ResidentialLeave",
                onModalCloseCallback: this.modalClose()
            });
        }

        private modalClose(residentid?: number, enquiryId?: number) {
            let residentId = residentid;
            let iluEnquiryId = enquiryId;
            const localState = this.$state;

            return function onModalClose(operation?: string, iluResidentId?: number, enquId?: number) {
                if (operation === 'admissionReversed') {
                    localState.go('viewLead.events', { residentId: residentId });
                }
                else if (operation === 'departureReversed' || operation === 'iluAdmissionCorrected' || operation === 'admissionCorrection') {
                    localState.reload();
                }
                else if (operation === 'iluAdmissionReversed') {
                    if (iluResidentId !== null && iluResidentId !== undefined) {
                        residentId = iluResidentId;
                    }
                    if (enquId !== null && enquId !== undefined) {
                        iluEnquiryId = enquId;
                    }

                    localState.go('viewEnquiry.events', { enquiryId: iluEnquiryId, residentId: residentId });
                }
                else {
                    localState.reload();
                }
            }
        }

        private getTemplate = (eventType: ResidentEventType, eventsHistoryItem: EventsHistoryRow): any => {
            switch (<any>eventType) {
                case "ResidentAdmitted":
                case "ResidentAdmissionCorrected":
                    let templateUrl = "app/residents/partials/residentAdmissionDialog.html";
                    let controller = "admissionCorrectionDialog.controller";
                    let modelConfig: any;
                    if (eventsHistoryItem.careType.toString() === "ILU") {
                        if (this.enquiry.residents.length > 1 && this.enquiry.residents[0].admissionTimeLocal === this.enquiry.residents[1].admissionTimeLocal && this.enquiry.residents[0].admissionDateUtc === this.enquiry.residents[1].admissionDateUtc) {
                            //Both residents have same admission date and time, so open dialog to correct / reverse both residents
                            templateUrl = "app/independentLiving/partials/admitToUnitDialog.html";
                            controller = "admitToUnitDialogController.controller";
                        }
                        else {
                            //Correct / reverse a single resident
                            templateUrl = "app/independentLiving/partials/addToUnitDialog.html";
                            controller = "addToUnitDialogController.controller";
                        }
                        modelConfig = {
                            isCorrection: true,
                            enquiryId: eventsHistoryItem.enquiryId,
                            enquiry: this.enquiry,
                            residencyId: eventsHistoryItem.residencyId,
                            latestAdmissionDate: this.eventHistory.latestResidency.admissionDate,
                            source: "eventsHistory",
                            isDeparted: eventsHistoryItem.isDeparted,
                            isReadOnly: this.isReadOnly,
                            hasReverseEventPermission: this.hasReverseEventPermission,
                            onModalCloseCallback: this.modalClose(this.residentId, eventsHistoryItem.enquiryId)
                        }
                    }
                    else {
                        modelConfig = {
                            residentId: this.residentId,
                            uniqueEventId: eventsHistoryItem.uniqueEventId,
                            isCorrection: true,
                            fromEventHistory: true,
                            requestType: !eventsHistoryItem.isPrivateResident ? eventsHistoryItem.medicareRequestType : 'ResidentialEntryCorrection',
                            isDeparted: eventsHistoryItem.isDeparted,
                            isReadOnly: this.isReadOnly,
                            onModalCloseCallback: this.modalClose(this.residentId)
                        }
                    }

                    return {
                        template: templateUrl, controller: controller, modelConfig: modelConfig
                    };
                case "ResidentDeparted":
                case "ResidentDepartureCorrected":
                    const admittedHistoryEvents = this.eventHistory.eventsHistory.filter(event =>
                        (event.eventType === "ResidentAdmitted" || event.eventType === "ResidentAdmissionCorrected") &&
                        this.eventHistory.latestResidency.admissionDate > eventsHistoryItem.eventDate
                    );
                    const filteredLeaves = this.eventHistory.leaves.filter(leave =>
                        leave.returnDateUtc <= eventsHistoryItem.eventDate
                    );

                    // Determine if there are admissions after departure
                    const hasAdmissionAfterDeparture = admittedHistoryEvents.length > 0;

                    // Determine the latest leave end date before current event date                    
                    const leaveEndDate = filteredLeaves.length > 0
                        ? filteredLeaves[0].returnDateUtc
                        : null;
                    
                    // Determine the latest leave type before current event date 
                    const isRespiteLeave = filteredLeaves.length > 0
                    ? filteredLeaves[0].type === 'Respite'
                    : false;

                    let templateResult = {
                        template: "app/residents/partials/departureDialog.html", controller: "departureDialog.controller", modelConfig: {
                            isReadOnly: this.isReadOnly,
                            hasReverseEventPermission: this.hasReverseEventPermission,
                            resident: {
                                id: this.residentId,
                                firstName: this.eventHistory.latestResidency.firstName,
                                lastName: this.eventHistory.latestResidency.lastName,
                                careType: eventsHistoryItem.careType
                            },
                            residencyId: eventsHistoryItem.residencyId,
                            uniqueEventId: eventsHistoryItem.uniqueEventId,
                            isCorrection: true,
                            fromEventHistory: true,
                            requestType: eventsHistoryItem.careType.toString() === "ILU"
                                ? "ResidentialILUDepartureCorrection"
                                : !eventsHistoryItem.isPrivateResident
                                    ? eventsHistoryItem.medicareRequestType
                                    : "ResidentialDepartureCorrection",
                            fromILU: eventsHistoryItem.careType.toString() === "ILU",
                            enquiryId: eventsHistoryItem.enquiryId,
                            leaveEndDate: leaveEndDate,
                            hasAdmissionAfterDeparture: hasAdmissionAfterDeparture,
                            isRespiteLeave: isRespiteLeave,
                            onModalCloseCallback: this.modalClose(this.residentId, eventsHistoryItem.enquiryId)
                        }
                    }
                    return templateResult;
            }
        }

        private setFundingCorrectEventsPermission = () => {
            this.authenticationService.userHasPermissionDeferred((x) => {
                return x.fundingCorrectEvents.canAction;
            }).then(() => {
                this.isReadOnly = false;
            }, () => {
                this.isReadOnly = true;
            });
        }

        private setFundingReverseEventsPermission = () => {
            this.authenticationService.userHasPermissionDeferred((x) => {
                return x.fundingReverseEvents.canAction;
            }).then(() => {
                this.hasReverseEventPermission = true;
            }, () => {
                this.hasReverseEventPermission = false;
            });
        }

        public canEdit = (editingHistoryItem: EventsHistoryRow): boolean => {

            if (editingHistoryItem.careType.toString() == "ILU" && editingHistoryItem.eventType.toString() == "ResidentDeparted" && editingHistoryItem.independentLivingAllocationWasSettled) {
                this.dialogService.openMessageDialog(
                    "Unable to edit",
                    "Departure cannot be edited.<br/>" +
                    "<span class='error-details'>Settlement has been finalised.</span>",
                    "correction-error");
                return false;
            }

            if (<any>editingHistoryItem.eventType == "ResidentAdmissionReversed" || <any>editingHistoryItem.eventType == "ResidentDepartureReversed") {
                this.dialogService.openMessageDialog("Unable to edit", "This event cannot be edited.", "correction-error");
                return false;
            }

            if (this.eventHistory.currentLoggedInFaclityId != editingHistoryItem.facilityId) {
                this.dialogService.openMessageDialog("Unable to edit", "This event cannot be edited as the event did not occur in logged in facility.", "correction-error");
                return false;
            }

            if (editingHistoryItem.careType.toString() !== "ILU" && this.eventHistory.latestResidency.admissionDate == null) {

                let message = "This event cannot be edited as this resident is currently a lead.";

                if (editingHistoryItem.facilityId != this.eventHistory.latestResidency.facilityId) {
                    message = `This event cannot be edited as this resident has been transferred to ${this.eventHistory.latestResidency.facilityName}. To modify this event you must delete the lead in ${this.eventHistory.latestResidency.facilityName}`;
                }

                this.dialogService.openMessageDialog("Unable to edit", message, "correction-error");

                return false;
            }

            if (editingHistoryItem.careType.toString() !== "ILU" && this.eventHistory.latestResidency.id != editingHistoryItem.residencyId) {

                this.dialogService.openMessageDialog("Unable to edit", "This event cannot be edited as this resident has been readmitted.",
                    "correction-error");
                return false;
            }
            return true;
        }
    }
}

export = ResidentEventHistoryComponent;